import { createSaga } from './saga-helpers';

import * as Api from '../api/milestones-api';

const watchGetMilestones = createSaga({
    type: 'MILESTONES_FETCH',
    fn: Api.fetchMilestones,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        milestones: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateMilestone = createSaga({
    type: 'MILESTONE_CREATE',
    fn: Api.createMilestone,
    args: action => [action.payload.milestone],
    successPayload: ({ id: milestoneId }, action) => ({
        milestoneId,
        fragment: action.payload.milestone
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.milestone
    })
});

const watchGetMilestone = createSaga({
    type: 'MILESTONE_FETCH',
    fn: Api.fetchMilestone,
    args: action => [action.payload.milestoneId],
    successPayload: milestone => ({ milestone }),
    errorPayload: (e, action) => ({
        removed: e === 'Milestone not found',
        milestoneId: action.payload.milestoneId
    })
});

const watchUpdateMilestone = createSaga({
    type: 'MILESTONE_UPDATE',
    fn: Api.updateMilestone,
    args: action => [action.payload.milestoneId, action.payload.milestoneProps],
    successPayload: milestone => ({ milestone })
});

const watchUpdateMilestones = createSaga({
    type: 'MILESTONES_UPDATE',
    fn: Api.updateMilestones,
    args: action => [action.payload.updatePairs],
    successPayload: milestones => ({ milestones })
});

const watchRemoveMilestone = createSaga({
    type: 'MILESTONE_REMOVE',
    fn: Api.removeMilestone,
    args: action => [action.payload.milestoneId]
});

const watchSetVisibility = createSaga({
    type: 'MILESTONE_VISIBILITY_SET',
    fn: Api.setVisibility,
    args: action => [action.payload.milestoneId, action.payload.visible, action.payload.roles]
});

const watchTieTasks = createSaga({
    type: 'MILESTONE_TIE_TASKS',
    fn: Api.tieTasks,
    args: action => [action.payload.milestoneId, action.payload.tasks]
});

const watchUntieTasks = createSaga({
    type: 'MILESTONE_UNTIE_TASKS',
    fn: Api.untieTasks,
    args: action => [action.payload.milestoneId, action.payload.tasks]
});

const watchMoveMilestone = createSaga({
    type: 'MILESTONE_MOVE',
    fn: Api.moveMilestone,
    args: action => [action.payload.milestoneId, action.payload.projectId]
});

const sagas = [watchGetMilestones, watchCreateMilestone, watchGetMilestone, watchUpdateMilestone, watchUpdateMilestones, watchRemoveMilestone, watchSetVisibility, watchTieTasks, watchUntieTasks, watchMoveMilestone];

export default sagas;
